<template>
  <b-form-input 
    v-model="local_input_value"
    @mousewheel.native="$event.preventDefault()"
    @input="inputChanged"
    :disabled="isDisabled"
    type="text" placeholder="0.00" step="any" min="0"
  />
</template>

<script>

export default {
  name: "NumberInput",
  components: {

  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      local_input_value: null
    }
  },
  computed: {
    input_value: {
      get () { return this.value },
      set (input_value) { this.$emit('input', input_value) }
    },
  },
  watch: {
    value () {
      this.local_input_value = this.input_value
      this.inputChanged()
    }
  },
  created () {
    this.local_input_value = this.input_value
  },
  methods: {
    inputChanged () {
      const regex = /^-?[0-9]*((,|\.)[0-9]*)?$/;
      if (!regex.test(this.local_input_value)) {
        this.$nextTick(() => {
          this.local_input_value = this.value
        })
      }

      if (this.local_input_value || this.local_input_value === 0) {
        let input_value = parseFloat(this.local_input_value.toString().replace(',','.'))
        
        if (!isNaN(input_value)) {
          this.input_value = input_value.toFixed(2)
        }

      } else {
        this.input_value = null
      }
    }
  }
}
</script>
